export default "__VITE_ASSET__EZLcYFdS__"